<template>
   <v-container style="margin-top:-20px;">
    <v-row align="center" justify="center">
      <v-col cols="12" md="6">
        <h2 class="mb-4">Meine Favoriten</h2>
        <v-card>
          <v-card-text>
            <div v-if="isLoadingSubscribedTopics && hasLogin">
              <v-skeleton-loader type="card"></v-skeleton-loader>
            </div>
            <div v-else>
              <div v-if="!hasLogin">
                <v-form ref="loginForm">
                  <p>Zur Verwaltung deiner Favoriten musst du dich mit deiner E-Mail-Adresse einloggen. Hast du noch keinen Account wird automatisch ein Neuer angelegt.</p>
                  <v-text-field
                    density="compact"
                    prepend-inner-icon="mdi-email-outline"
                    variant="outlined"
                    label="E-Mail"
                    v-model="email"
                    @input="onLoginInput"
                    @keypress.native.enter="onClickLogin"
                    @keyup.enter.stop="onClickLogin"
                    type="email"
                    required
                  ></v-text-field>
                  <v-btn :disabled="loginHint" outlined block @click="onClickLogin">Anmelden</v-btn>
                  <p v-if="loginHint" class="mt-4" style="color:green">Bitte prüfe dein E-Mail-Postfach. Du findest dort alle weiteren Informationen, die du benötigst, um dich erfolgreich einzuloggen.</p>
                </v-form>
              </div>
              <div v-else>
                <p v-if="hasSubscribedTopics">Hier findest du deine Suchbegriffe, zu denen wir dich bei Neuigkeiten per E-Mail informieren.</p>
                <v-list v-if="hasSubscribedTopics">
                  
                  <v-list-item
                    v-for="(value,keyword) in subscribedTopics"
                    :key="keyword"
                    @click="menuActionClick(keyword,value)"
                    class="line-bottom"

                  >
                    <v-list-item-title><b>{{ keyword }}</b></v-list-item-title>
                    <v-list-item-action @click.stop="unsubscribe(token,keyword)">
                        <v-btn icon @click.stop="unsubscribe(token,keyword)">
                          <v-icon color="red lighten-1">mdi-minus</v-icon>
                        </v-btn>
                      </v-list-item-action>
                  </v-list-item>
                  
                </v-list>
                <div v-else>
                  <p>Du hast aktuell noch keine Favoriten hinterlegt über die wir dich bei Neuigkeiten benachrichtigen können.</p>
                </div>
                
              </div>
            </div>
          </v-card-text>
        </v-card>
        <h2 v-if="hasLogin" class="mt-10 mb-4">Mein Account</h2>
        <v-card v-if="hasLogin">
          <v-card-text>
          <p>Wenn du keine E-Mail-Benachrichtigungen mehr erhalten und deinen Account dauerhaft löschen möchtest, kannst klick zweimal auf "Account löschen"</p>
          <div class="pa-5"><v-btn :outlined="!deleteClicked" block :class="(deleteClicked)?'white--text':''" color="red" @click="deleteSecure">{{(deleteClicked)?'Bist du dicher?':'Account löschen'}}</v-btn></div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import apiMethods from '@/mixins/apiMethods.js';
export default {
  mixins:[apiMethods],
  data() {
    return {
      email: "",
      loading: true,
      loginHint:false,
      deleteClicked:false
    };
  },
  methods: {
    onClickLogin(){
      this.registerUser(this.email,()=>{
        this.loginHint=true;
      })
    },
    onLoginInput(){
      this.loginHint=false;
    },
    menuActionClick(keyword,value){
      //Go to index
      const exact =(value)?value.exact:false;
      this.$router.push({ name: 'home',query: { search: keyword, exact:exact} });
    },
    deleteSecure(){
      
      if(this.deleteClicked){
        this.deleteAll(()=>{
          this.deleteClicked=false;
          this.$router.push({ name: 'home'});
        });
      }
      this.deleteClicked=true;

      setTimeout(()=>{
        this.deleteClicked=false;
      },3000);
    }
  },
};
</script>
<style>
/* Optional: Anpassung der Divider-Dicke und Farbe */
.line-bottom {
  border-bottom-color: #d0d0d0 !important;
  border-bottom-width: 1px;
  border-bottom-style: solid !important;
  padding-left:5px;
}
</style>
